var _rect, _rect2, _rect3, _path, _circle, _rect4, _rect5, _rect6, _rect7, _circle2, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.61582,
    y: 8.10029,
    width: 25.2794,
    height: 14.0561,
    rx: 0.45,
    fill: "#67D676",
    stroke: "#00753B",
    strokeWidth: 0.7
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.00449,
    y: 6.66135,
    width: 25.2794,
    height: 14.0561,
    rx: 0.45,
    fill: "#67D676",
    stroke: "#00753B",
    strokeWidth: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6137 17.5579C24.8063 17.5571 24.9621 17.4007 24.9621 17.2079V10.0685C24.9621 9.87533 24.8056 9.71871 24.6125 9.71851L24.6128 9.71851L24.6133 9.71851L24.614 9.71852L24.6136 9.71851L24.6063 9.7183C24.5986 9.71801 24.5855 9.71737 24.5678 9.71595C24.5322 9.71311 24.4788 9.70722 24.4137 9.69509C24.282 9.67054 24.1107 9.62204 23.9428 9.52822C23.777 9.43556 23.6161 9.29974 23.4951 9.09689C23.3744 8.89447 23.282 8.60609 23.282 8.19034C23.282 7.99704 23.1253 7.84034 22.932 7.84034H4.25628C4.06298 7.84034 3.90628 7.99704 3.90628 8.19034C3.90628 9.00655 3.56951 9.36035 3.27665 9.53161C3.1188 9.62392 2.95787 9.67155 2.83435 9.69563C2.77325 9.70754 2.7233 9.7133 2.69026 9.71606C2.6738 9.71743 2.66173 9.71805 2.65479 9.71832L2.6484 9.71852C2.64801 9.71852 2.64798 9.71852 2.64831 9.71852L2.64907 9.71851L2.64966 9.71851L2.65001 9.71851C2.6502 9.71851 2.65039 9.71851 2.65039 10.0685V9.71851C2.45709 9.71851 2.30039 9.87521 2.30039 10.0685V17.2079C2.30039 17.4012 2.45709 17.5579 2.65039 17.5579V17.2079C2.65039 17.5579 2.6502 17.5579 2.65002 17.5579H2.64969L2.64914 17.5579L2.65533 17.5581C2.66246 17.5584 2.67473 17.559 2.69141 17.5603C2.72488 17.563 2.77532 17.5686 2.83692 17.5801C2.96157 17.6035 3.12349 17.6495 3.28198 17.7385C3.43839 17.8263 3.59019 17.955 3.7044 18.1474C3.81838 18.3394 3.90628 18.614 3.90628 19.0113C3.90628 19.2046 4.06298 19.3613 4.25628 19.3613H22.932C23.1253 19.3613 23.282 19.2046 23.282 19.0113C23.282 18.6168 23.3732 18.3445 23.4918 18.1534C23.6112 17.9613 23.7709 17.8312 23.9376 17.7417C24.1061 17.6513 24.2784 17.6044 24.4112 17.5806C24.4769 17.5689 24.5307 17.5632 24.5667 17.5604C24.5846 17.559 24.5979 17.5584 24.6058 17.5581L24.6134 17.5579L24.6137 17.5579ZM24.6137 17.5579C24.6133 17.5579 24.6129 17.5579 24.6125 17.5579H24.6128L24.6133 17.5579L24.6139 17.5579L24.6137 17.5579Z",
    fill: "#71EF81",
    stroke: "#00753B",
    strokeWidth: 0.7,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.6436,
    cy: 13.6897,
    r: 4.47012,
    fill: "#67D676",
    stroke: "#00753B",
    strokeWidth: 0.7
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18.1061,
    y: 16.4099,
    width: 11.6528,
    height: 2.11856,
    rx: 0.45,
    fill: "#FFD978",
    stroke: "#AD7F0A",
    strokeWidth: 0.7
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 18.1061,
    y: 18.6813,
    width: 12.89,
    height: 2.11856,
    rx: 0.45,
    fill: "#FFD978",
    stroke: "#AD7F0A",
    strokeWidth: 0.7
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 19.8912,
    y: 23.221,
    width: 11.1048,
    height: 2.11856,
    rx: 0.45,
    fill: "#FFD978",
    stroke: "#AD7F0A",
    strokeWidth: 0.7
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 19.1754,
    y: 20.9511,
    width: 11.0647,
    height: 2.11856,
    rx: 0.45,
    fill: "#FFD978",
    stroke: "#AD7F0A",
    strokeWidth: 0.7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.3923,
    cy: 20.368,
    r: 4.97084,
    fill: "#FFD978",
    stroke: "#AD7F0A",
    strokeWidth: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4101 15.2916C13.1491 15.2916 12.9163 15.2249 12.7115 15.0917C12.5081 14.957 12.3481 14.7655 12.2317 14.5172C12.1167 14.2675 12.0592 13.968 12.0592 13.6187C12.0592 13.2694 12.1174 12.9706 12.2338 12.7223C12.3517 12.474 12.513 12.284 12.7178 12.1521C12.9226 12.0202 13.1548 11.9543 13.4143 11.9543C13.6149 11.9543 13.7762 11.988 13.8982 12.0553C14.0217 12.1212 14.1171 12.1984 14.1844 12.2868C14.2532 12.3751 14.3065 12.453 14.3443 12.5203H14.3822V10.919H15.0114V15.2284H14.3969V14.7255H14.3443C14.3065 14.7943 14.2517 14.8728 14.1802 14.9612C14.1101 15.0496 14.0133 15.1267 13.8898 15.1927C13.7664 15.2586 13.6065 15.2916 13.4101 15.2916ZM13.5489 14.755C13.7299 14.755 13.8828 14.7073 14.0077 14.6119C14.1339 14.5151 14.2293 14.3811 14.2938 14.21C14.3598 14.0389 14.3927 13.8397 14.3927 13.6124C14.3927 13.388 14.3605 13.1916 14.2959 13.0232C14.2314 12.8549 14.1367 12.7237 14.0119 12.6298C13.887 12.5358 13.7327 12.4888 13.5489 12.4888C13.3596 12.4888 13.2018 12.5379 13.0755 12.6361C12.9492 12.7343 12.8539 12.8682 12.7893 13.038C12.7262 13.2077 12.6946 13.3992 12.6946 13.6124C12.6946 13.8284 12.7269 14.0227 12.7914 14.1953C12.856 14.3678 12.9514 14.5046 13.0776 14.6056C13.2053 14.7052 13.3624 14.755 13.5489 14.755ZM13.509 11.7376V11.302H15.4427V11.7376H13.509Z",
    fill: "#00753B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7754 15.8297H15.483V16.2338H11.7754V15.8297Z",
    fill: "#00753B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1337 22.3281C19.8286 22.3281 19.5564 22.2502 19.3169 22.0944C19.0791 21.937 18.8921 21.7131 18.756 21.4228C18.6215 21.1308 18.5543 20.7807 18.5543 20.3723C18.5543 19.9639 18.6223 19.6146 18.7585 19.3243C18.8962 19.034 19.0848 18.8117 19.3243 18.6576C19.5638 18.5034 19.8352 18.4263 20.1386 18.4263C20.3731 18.4263 20.5618 18.4657 20.7044 18.5444C20.8488 18.6215 20.9603 18.7117 21.039 18.815C21.1194 18.9183 21.1817 19.0094 21.226 19.0881H21.2703V17.2159H22.0059V22.2543H21.2875V21.6663H21.226C21.1817 21.7467 21.1178 21.8385 21.0341 21.9419C20.9521 22.0452 20.8389 22.1354 20.6946 22.2125C20.5503 22.2896 20.3633 22.3281 20.1337 22.3281ZM20.2961 21.7008C20.5076 21.7008 20.6864 21.645 20.8324 21.5335C20.98 21.4203 21.0915 21.2637 21.167 21.0636C21.244 20.8635 21.2826 20.6306 21.2826 20.3649C21.2826 20.1025 21.2449 19.8729 21.1694 19.6761C21.094 19.4793 20.9833 19.3259 20.8373 19.216C20.6913 19.1061 20.5109 19.0512 20.2961 19.0512C20.0746 19.0512 19.8901 19.1086 19.7425 19.2234C19.5949 19.3382 19.4834 19.4948 19.4079 19.6933C19.3341 19.8917 19.2972 20.1156 19.2972 20.3649C19.2972 20.6175 19.335 20.8446 19.4104 21.0464C19.4858 21.2481 19.5974 21.408 19.745 21.5261C19.8942 21.6426 20.0779 21.7008 20.2961 21.7008ZM20.2493 18.1729V17.6637H22.5102V18.1729H20.2493Z",
    fill: "#AD7F0A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2246 23.0476H22.5594V23.5199H18.2246V23.0476Z",
    fill: "#AD7F0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCash);
export default __webpack_public_path__ + "static/media/ic-cash.0ac4759cea10b1f76d9c16efdc39d2d6.svg";
export { ForwardRef as ReactComponent };